import React from "react";
import RouterUtils from "../../../utils/RouterUtils.js";
import * as ROUTES from "../../../constants/routes.js";
import ActionButton from "../../common/widgets/ActionButton.js";
import ApplicationItem from "../view/ApplicationItem.js";
import "./ApplicationSearchResult.scss"
import useReferrer from "../../infra-no-ui/navigation/useReferrer";

export default function ApplicationSearchResult(props) {
  const { item: application } = props;

  const {redirectTo} = useReferrer();

  function onClickCandidate(event, candidateId) {
    event.preventDefault();
    redirectTo(
      RouterUtils.injectParamsInRoute(ROUTES.RECRUITER_CANDIDATE_PROFILE, {
        candidateId,
      })
    );
  }

  return (
    <ActionButton
      as={"div"}
      variant="outline-primary"
      onClick={(event) => onClickCandidate(event, application.candidateId)}
      className={"ApplicationSearchResult"}
    >
      <ApplicationItem application={application} />
    </ActionButton>
  );
}
